export const questions = [
    {
      id: 1,
      question:
        "If you point at something across the room, does your child look at it?",
      example:
        "if you point at a toy or an animal, does your child look at the toy or animal?",
    },
    {
      id: 2,
      question: "Have you ever wondered if your child might be deaf?",
      example: "",
    },
    {
      id: 3,
      question: "Does your child play pretend or make-believe?",
      example:
        "pretend to drink from an empty cup, pretend to talk on a phone, or pretend to feed a doll or stuffed animal?",
    },
    {
      id: 4,
      question: "Does your child like climbing on things?",
      example: "furniture, playground equipment, or stairs",
    },
    {
      id: 5,
      question:
        "Does your child make unusual finger movements near his or her eyes?",
      example:
        "does your child wiggle his or her fingers close to his or her eyes?",
    },
    {
      id: 6,
      question:
        "Does your child point with one finger to ask for something or to get help?",
      example: "pointing to a snack or toy that is out of reach",
    },
    {
      id: 7,
      question:
        "Does your child point with one finger to show you something interesting?",
      example: "pointing to an airplane in the sky or a big truck in the road",
    },
    {
      id: 8,
      question: "Is your child interested in other children?",
      example:
        "does your child watch other children, smile at them, or go to them?",
    },
    {
      id: 9,
      question:
        "Does your child show you things by bringing them to you or holding them up for you to see — not to get help, but just to share?",
      example: "showing you a flower, a stuffed animal, or a toy truck",
    },
    {
      id: 10,
      question: "Does your child respond when you call his or her name?",
      example:
        "does he or she look up, talk or babble, or stop what he or she is doing when you call his or her name?",
    },
    {
      id: 11,
      question: "When you smile at your child, does he or she smile back at you?",
      example: "",
    },
    {
      id: 12,
      question: "Does your child get upset by everyday noises?",
      example:
        "does your child scream or cry to noise such as a vacuum cleaner or loud music?",
    },
    {
      id: 13,
      question: "Does your child walk?",
      example: "",
    },
    {
      id: 14,
      question:
        "Does your child look you in the eye when you are talking to him or her, playing with him or her, or dressing him or her?",
      example: "",
    },
    {
      id: 15,
      question: "Does your child try to copy what you do?",
      example: "wave bye-bye, clap, or make a funny noise when you do",
    },
    {
      id: 16,
      question:
        "If you turn your head to look at something, does your child look around to see what you are looking at?",
      example: "",
    },
    {
      id: 17,
      question: "Does your child try to get you to watch him or her?",
      example:
        "does your child look at you for praise, or say “look” or “watch me”?",
    },
    {
      id: 18,
      question:
        "Does your child understand when you tell him or her to do something?",
      example: `if you don't point, can your child understand “put the book on the chair” or “bring me the blanket”?`,
    },
    {
      id: 19,
      question:
        "If something new happens, does your child look at your face to see how you feel about it?",
      example:
        "if he or she hears a strange or funny noise, or sees a new toy, will he or she look at your face?",
    },
    {
      id: 20,
      question: "Does your child like movement activities?",
      example: "being swung or bounced on your knee",
    },
  ];

  export const ANSWERSTATE = {
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    q11: "",
    q12: "",
    q13: "",
    q14: "",
    q15: "",
    q16: "",
    q17: "",
    q18: "",
    q19: "",
    q20: ""
  };